import { FileText } from 'lucide-react'
import type { NavEntry } from '@/app/nav-registry'

/** Nav entries only — imported by the eager shell bundle; keep free of pages/api (H-10). */

export const documentsNav: NavEntry = {
  label: 'Documents',
  icon: FileText,
  path: '/documents',
  permission: 'documents:read',
  order: 50,
}
